module.exports = __webpack_public_path__ + "media/john_cena.1667b329.mp3";